import React, { memo } from "react";

import { SkeletonLoader } from "@whoosh/design-system/src/components/display";
import {
  Box,
  HStack,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

const FEATURE_COUNT = 3;
const NOTE_LINES = 2;

export const BookingSummaryContentSkeleton = memo(
  ({ isMobile }: { isMobile: boolean }) => (
    <Box testID="booking-summary-skeleton-body">
      <SkeletonLoader
        testID="booking-summary-skeleton-body-title"
        height={16}
        width={130}
        borderRadius="1"
      />
      <HStack gap={2} justifyContent="space-between" marginTop={2}>
        <Box
          flex={2}
          flexDirection={isMobile ? "column" : "row"}
          justifyContent="space-between"
          gap={isMobile ? 2 : 0}
        >
          <SkeletonLoader
            testID="booking-summary-skeleton-body-subtitle"
            height={20}
            width={260}
            borderRadius="1"
          />
          <SkeletonLoader
            testID="booking-summary-skeleton-body-subtitle"
            height={20}
            width={isMobile ? "100%" : 260}
            borderRadius="1"
          />
        </Box>
      </HStack>
      <Box style={{ marginTop: 48 }}>
        <SkeletonLoader
          testID="booking-summary-skeleton-body-section-title"
          height={20}
          width={140}
          borderRadius="1"
        />
      </Box>

      <VStack style={{ marginTop: 34 }} gap={5}>
        {Array.from({ length: FEATURE_COUNT }).map((_, idx) => (
          <HStack gap={3} alignItems="center" key={`feature-${idx}`}>
            <SkeletonLoader
              testID="booking-summary-skeleton-body-feature-icon"
              height={24}
              width={24}
              borderRadius="1"
            />
            <SkeletonLoader
              testID="booking-summary-skeleton-body-feature-text"
              height={12}
              width={160}
              borderRadius="1"
            />
          </HStack>
        ))}
      </VStack>

      <VStack style={{ marginTop: 28 }} gap={3}>
        <SkeletonLoader
          testID="booking-summary-skeleton-body-card"
          height={48}
          width="100%"
          borderRadius="1"
        />
        <SkeletonLoader
          testID="booking-summary-skeleton-body-card"
          height={48}
          width="100%"
          borderRadius="1"
        />
      </VStack>

      <VStack style={{ marginTop: 46 }}>
        <SkeletonLoader
          testID="booking-summary-skeleton-body-note-title"
          height={20}
          width={140}
          borderRadius="1"
        />

        <VStack gap={5} style={{ marginTop: 26 }}>
          {Array.from({ length: NOTE_LINES }).map((_, idx) => (
            <SkeletonLoader
              key={`note-${idx}`}
              testID="booking-summary-skeleton-body-note"
              height={12}
              width="100%"
              borderRadius="1"
            />
          ))}
          <SkeletonLoader
            testID="booking-summary-skeleton-body-note"
            height={12}
            width="55%"
            borderRadius="1"
          />
        </VStack>
      </VStack>
    </Box>
  )
);
